import LegalPage, { ScrollText } from "@/pages/LegalPage";

export default function TermsOfUse() {
  return (
    <LegalPage
      slug="terms"
      defaultTitle="Termos de Uso"
      badge="Documento Legal"
      icon={ScrollText}
      siblingSlug="politica-de-privacidade"
      siblingLabel="Ver Política de Privacidade"
    />
  );
}
